import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HIDE_ALERT_DEFAULT_TIME_IN_SECONDS } from '../../../../constants/AlertConstants';

import { hideAlert } from '../../../../actions/alert.action';
import { EAlertType } from '../../../../types/alert.types';
import { IInitialState } from '../../../../types/initialState.types';
import Icon from '../../../../components/Common/Icon/Icon';
import styles from './Alert.module.css';

const ErrorAlert = () => {
  const dispatch = useDispatch();
  const { show, message, type, hideInSeconds, version } = useSelector(
    (state: IInitialState) => state?.alert
  );

  const onDismiss = () => {
    dispatch(hideAlert());
  };

  useEffect(() => {
    if (type !== EAlertType.ERROR) {
      const hideTimeout = setTimeout(() => {
        onDismiss();
        clearTimeout(hideTimeout);
      }, (hideInSeconds ?? HIDE_ALERT_DEFAULT_TIME_IN_SECONDS) * 1000);
      return () => {
        clearTimeout(hideTimeout);
      };
    }
  }, [type, hideInSeconds]);

  if (!show || !message || version !== 'v1') {
    return null;
  }

  return (
    <div
      className={`${styles.alertContainer} ${styles[type || EAlertType.INFO]}`}
    >
      <div className={styles.iconWrapper}>
        <Icon name="infoOutline" />
      </div>
      <div className={styles.message}>
        <div>{message}</div>
      </div>
      <div className={styles.closeIconWrapper} onClick={onDismiss}>
        <Icon name="close" />
      </div>
    </div>
  );
};

export default ErrorAlert;
